var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 143,
    viewBox: "0 0 146 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.681 107.922C139.069 97.2311 142.739 84.729 142.739 71.3697C142.739 31.9533 110.786 0 71.3697 0C31.9533 0 0 31.9533 0 71.3697C0 110.786 31.9533 142.739 71.3697 142.739C86.8795 142.739 101.234 137.792 112.94 129.389L146 142.377L132.681 107.922Z",
    fill: "#6A01FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1666 49.1666H97.8332C101.454 49.1666 104.417 51.6791 104.417 54.75V88.25C104.417 91.3208 101.454 93.8333 97.8332 93.8333H45.1666C41.5458 93.8333 38.5833 91.3208 38.5833 88.25V54.75C38.5833 51.6791 41.5458 49.1666 45.1666 49.1666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.417 54.75L71.4999 74.2916L38.5833 54.75",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.417 54.75C104.417 51.6791 101.454 49.1666 97.8332 49.1666H45.1666C41.5458 49.1666 38.5833 51.6791 38.5833 54.75M104.417 54.75V88.25C104.417 91.3208 101.454 93.8333 97.8332 93.8333H45.1666C41.5458 93.8333 38.5833 91.3208 38.5833 88.25V54.75M104.417 54.75L71.4999 74.2916L38.5833 54.75",
    stroke: "#6A01FE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopOpen);
export default __webpack_public_path__ + "static/media/envelop-open.a9de7f9aa2c3430777b62f6ee9ed5d66.svg";
export { ForwardRef as ReactComponent };